export const setCurrentPage = (prevPage: number, page: number) => page;
export const setPageSize = (prevPageSize: number, size: number) => size;
